type ClassValue = string | number | null | undefined | false | ClassValue[];

/** Joins classes; deliberately does NOT resolve Tailwind conflicts — those are
 *  a smell to fix at the call site. Wrap `tailwind-merge` here if ever needed. */
export const cn = (...inputs: ClassValue[]): string => {
  const out: string[] = [];

  for (const input of inputs) {
    if (!input) continue;
    if (Array.isArray(input)) {
      const nested = cn(...input);
      if (nested) out.push(nested);
    } else {
      out.push(String(input));
    }
  }

  return out.join(' ');
};
